/* libs/oyan-ui/src/lib/features/auth/containers/login/login.component.scss */
.login-page {
  height: 100vh;
  max-width: 1176px;
  width: 100%;
  background: #f4f8f9;
  margin: auto;
}
.login-page__content {
  width: 100%;
  height: 100%;
}
.login-page__bg-img {
  width: 100%;
  height: auto;
  min-height: 37rem;
  background-image: url(/assets/images/auth/fond_login.png);
  background-position-x: 38%;
  background-position-y: 18%;
  background-repeat: no-repeat;
  background-size: 199%;
  overflow: hidden;
}
@media (max-width: 958px) {
  .login-page__bg-img {
    min-height: 30rem;
  }
}
@media (min-width: 959px) and (max-width: 1037px) {
  .login-page__bg-img {
    min-height: 32rem;
  }
}
@media (min-width: 1038px) and (max-width: 1100px) {
  .login-page__bg-img {
    min-height: 34rem;
    background-position-x: 37%;
    background-size: 195%;
  }
}
.login-page__form-layout {
  width: 100%;
  overflow: hidden;
  z-index: 1;
  border-radius: 0 50% 50% 50%;
  position: relative;
}
.login-page__info {
  position: absolute;
  color: #fff;
  right: 0;
  top: 22%;
  padding: 50px 20px 50px 15%;
  min-height: 20.8rem;
  box-sizing: border-box;
  border: 5px solid;
  border-right: 0;
  border-radius: 50vh 0 0 50vh;
  box-shadow: 0 16.4236px 32.8473px rgba(0, 33, 91, 0.15);
  max-width: 80%;
  width: 100%;
}
@media (max-width: 958px) {
  .login-page__info {
    top: 15%;
  }
}
@media (min-width: 959px) and (max-width: 1037px) {
  .login-page__info {
    top: 17%;
  }
}
@media (min-width: 1038px) and (max-width: 1100px) {
  .login-page__info {
    top: 19%;
  }
}
.login-page__info-welcome {
  padding-left: 50px;
  position: absolute;
  top: 36%;
  left: 38%;
  z-index: 1;
}
.login-page__info-welcome h2 {
  font-size: 20px;
  line-height: 28px;
}
.login-page__info-welcome h3 {
  opacity: 0.4;
  font-size: 14px;
  line-height: 20px;
}
.login-page__info-logo {
  padding-top: 10px;
  padding-bottom: 10px;
}
.login-page__info-logo .mat-icon {
  width: 200px;
  height: 100%;
}
.login-page__form {
  box-shadow: 0 4.10591px 10.2648px rgba(0, 33, 91, 0.05);
  left: -20%;
  top: -2px;
  width: 100%;
  height: 20.8rem;
  position: relative;
  background-color: #fff;
  border: 5px solid #efeff4;
  box-sizing: border-box;
  border-radius: 0px 32px 32px 0px;
  border-left: 0;
  overflow: hidden;
}
.login-page__form .mat-mdc-card {
  box-shadow: none;
  padding-left: 26%;
  padding-top: 20px;
  margin-right: 40px;
}
.login-page__form .mat-mdc-card-title {
  font-size: 26px;
  font-weight: 700;
  line-height: 100%;
  margin-bottom: 18px;
}
.login-page__footer .mat-icon {
  width: 180px !important;
  position: absolute;
  right: 10%;
  bottom: 2.5rem;
  height: 4.2rem;
}
.login-page__footer.step-password .mat-icon {
  bottom: 0;
}
/*# sourceMappingURL=login.component.css.map */
